<div class="flex items-center justify-end gap-1.5">
  @if (showMinSpendIndicator) {
    <lucide-icon
      [size]="14"
      [name]="BadgeCheck"
      class="text-green-600 dark:text-green-400"
      title="Counts towards minimum spend">
    </lucide-icon>
  }
  @if (showDiscontinuedIndicator) {
    <span class="text-xs text-orange-600 dark:text-orange-400">• Discontinued</span>
  }

  @if (isOfferItem && discountAmount > 0) {
    <div class="flex flex-col items-end gap-0.5">
      <div class="flex items-center gap-1.5">
        <lucide-icon
          [size]="14"
          [name]="Gift"
          class="text-green-600 dark:text-green-400"
          title="£150 Offer Applied">
        </lucide-icon>
        <span class="text-xs text-gray-500 dark:text-gray-400 line-through">{{ displayPrice | currency:'GBP' }}</span>
        <span class="text-sm font-semibold text-green-600 dark:text-green-500">{{ discountedPrice | currency:'GBP' }}</span>
      </div>
      <span class="text-[10px] text-green-600 dark:text-green-500">-{{ discountAmount | currency:'GBP' }} discount</span>
    </div>
  } @else {
    <span class="text-sm font-medium">{{ displayPrice | currency:'GBP' }}</span>
  }
</div>
